import axios from 'axios';

export const pharmaSend = axios.create({
	baseURL: import.meta.env.VITE_PUBLIC_SalesTaxAPI_URL,
	headers: {
		'x-store-key': import.meta.env.VITE_STORE_KEY,
	},
});
